import DeltaAirline from './components/DeltaAirline';

const AirlineDetail = () => {
  return (
    <>
      <DeltaAirline />
    </>
  );
};

export default AirlineDetail;
